<script>
import { elDrag } from '@/allotment/directive'

export default {
  props: {
    value: { type: Boolean, default: false }, //是否显示
    footer: { type: Boolean, default: true }, //是否显示底部操作
    title: { type: String, default: '' }, //弹窗标题
    width: { type: String, default: '500px' }, //弹窗宽度
    cancel: { type: Boolean, default: true }, //取消按钮
    define: { type: Boolean, default: true }, //确定按钮
    defineClose: { type: Boolean, default: true }, //默认确定关闭
    defineText: { type: String, default: '' }, //自定义确定按钮文字
    loading: { type: Boolean, default: false } //加载中
  },

  directives: {
    elDrag
  },

  data() {
    return {
      visible: this.value || false //弹窗是否显示
    }
  },

  watch: {
    //监听外部传入是否显示
    value: {
      handler() {
        this.visible = this.value
      }
    },

    //监听内部显隐改变事件
    visible: {
      handler() {
        this.$emit('input', this.visible)
      }
    }
  },

  methods: {
    //确认事件
    onDefine() {
      if(this.defineClose) this.visible = false
      this.$emit('define')
    },

    //关闭事件
    onClose(done) {
      this.$emit('close')

      done()
    },

    // 用户自定义关闭
    onCancel() {
      this.visible = false
      this.$emit('close')
    }
  }
}
</script>

<template>
  <el-dialog
    v-el-drag="{ minWidth: 200, minHeight: 200 }"
    :title="title"
    :visible.sync="visible"
    :append-to-body="true"
    :close-on-click-modal="false"
    :width="width"
    custom-class="dialog"
    :before-close="onClose"
  >
    <template #title>
      <slot name="title"></slot>
    </template>

    <slot></slot>

    <!--底部操作按钮-->
    <div v-if="footer" slot="footer" class="dialog-footer">
      <div class="dialog-footer-left">
        <slot name="footer"></slot>
      </div>

      <div class="dialog-footer-right">
        <el-button v-if="cancel" size="medium" @click="onCancel">{{ $t('dialog.cancel') }}</el-button>
        <el-button v-if="define" type="primary" size="medium" :loading="loading" @click="onDefine">{{ defineText ? defineText : $t('dialog.define') }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<style lang="scss">
.dialog{
  display: flex;
  flex-direction: column;

  .el-dialog__body{
    flex: 1;
    overflow-y: auto;
  }

  &-footer{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
